<script>
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import CompanyRequest from 'Modules/contacard/company/CompanyRequest';
import DataTableCpfCnpjColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableCpfCnpjColumn.vue';
import DataTableDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';

export default {
  name: 'CompanyList',
  extends: CrudListVue,
  data: () => ({
    requestClass: CompanyRequest,
    editRoute: 'company.edit',
    headers: [
      {
        text: 'Código',
        value: 'id',
      },
      {
        text: 'Empresa',
        value: 'nomEmpresa',
      },
      {
        text: 'Razão social',
        value: 'nomRazaoSocial',
      },
      {
        text: 'CNPJ',
        value: 'cnpj',
        component: DataTableCpfCnpjColumnVue,
      },
      {
        text: 'Código tendência',
        value: 'codEmpresaTendencia',
      },
      {
        text: 'Última atualização',
        value: 'updatedDate',
        component: DataTableDateColumnVue,
      },
    ],
  }),
};
</script>
